import { Link } from 'react-router-dom'
import { styled } from 'styled-components'
import { colors } from 'src/styles/theme'

export const MenuWrapper = styled(Link)<{ $isMobile?: boolean }>`
  display: flex;
  align-items: center;
  padding: 10px 16px;
  height: ${(props) => (props.$isMobile ? '48px' : '82px')};
  text-decoration: none;
  border-radius: 8px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${colors.neutral200};
  }

  ${(props) =>
    props.$isMobile &&
    `
    width: 100%;
  `}
`
